src/components/Evaliate.vue
<template>
  <div class="evaluate">
    <a id="back" @click="back()">戻る</a>
    <br />
    <img id="gazou" src="@/assets/photo01.jpg" />
    <h2>評価システムについて</h2>
    <div id="box">
      <div id="aboutText">
        <p id="summary">
          コロナにまけるな短編小説コンテストでは評価を付けることができます。
          気に入った作品には評価を付けて応援しましょう。評価にはログイン（メールアドレスのみ）が必要で
          す。評価には「いいね」と「投票」の 2 種類があります。
          それぞれ違いがあるので確認した上で評価を付けてください。
        </p>
        <br />1. いいね
        <br />
        <p id="iine">
          全ての作品につき、1 回付けることができます。1 つの作品には 1 回しか付けること
          ができません。つまり 50 作品あれば、それぞれに 1 回ずつ、合計 50 個いいねを付け
          ることができます。審査には影響しません。
        </p>
        <br />2. 投票
        <br />
        <p id="touhyou">
          全ての作品の中から 1 回だけ付けることができます。50 作品あったとしても、投票で
          きるのは 1 作品だけです。複数回投票した場合、最後に投票した作品に反映されま
          す。審査に影響することがあります。
        </p>
        <br />
      </div>
    </div>
    <a id="back2" @click="back()">戻る</a>
  </div>
</template>

<script>
export default {
  name: "nomatch",
  data: () => ({}),
  methods: {
    back: function() {
      this.$router.go(-1);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.evaluate {
  width: 100%;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
  cursor: pointer;
}
#box {
  width: 100%;
  max-width: 740px;
  margin-left: auto;
  margin-right: auto;
}
#aboutText {
  text-align: left;
  margin-left: auto;
  margin-right: auto;
  width: fit-content;
  padding-left: 2%;
  word-wrap: break-word;
}
#summary {
}
#iine,
#touhyou {
  padding-left: 4%;
}
#touhyou {
}
#gazou {
  width: 90%;
  max-width: 650px;
}
.no_cut {
  display: inline-block;
}
#kuuhaku {
  white-space: pre-wrap;
}
#back,
#back2 {
  margin-right: 80%;
  text-align: center;
}
</style>